import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import st from './style.module.scss';

const ReadMoreButton = ({ link, textBtn }) => {
  return (
    <div className="col-12 px-2">
      <div className={st.readMoreButtonWrapper}>
        <Link to={link} target="_blank">
          <Button className={st.readMoreButton}>{textBtn}</Button>
        </Link>
      </div>
    </div>
  );
};

export default ReadMoreButton;
